<template>
  <section class="section --banner" :style="`--card-slide-duration: ${sliderSpeed}ms`">
    <CategoriesBannerContent :content="content" />
    <div class="category__card-mobile-slider" ref="mobileSlider">
      <CategoryCard
        v-for="(category, mobileCategoryIndex) in $store.state.categories.items"
        :category="category"
        :priority="mobileCategoryIndex === 0"
        :key="category.id"
        :class="['--slider', { '--current': mobileCategoryIndex === currentStep }]"
      />
    </div>
    <TransitionGroup tag="div" class="category__card-desktop-slider" v-reveal="{ delay: 200 }">
      <CategoryCard
        v-for="(category, categoryIndex) in desktopCategories"
        :category="category"
        :priority="categoryIndex < 3"
        :key="category.id"
        :class="['--slider', { '--current': categoryIndex === 0 }]"
      />
    </TransitionGroup>
    <RoundTextButton
      :is-max="false"
      class="--banner"
      @click="changeSlide"
      v-reveal="{ delay: 300 }"
    />
  </section>
</template>

<script>
import { CategoriesBannerContent } from '@/components/blocks'
import { CategoryCard } from '@/components/cards'
import { RoundTextButton } from '@/components/small'
import { DefaultSectionProps } from '@/mixins'

export default {
  name: 'CategoriesBannerSection',
  mixins: [DefaultSectionProps],
  components: { CategoriesBannerContent, CategoryCard, RoundTextButton },
  data() {
    return {
      currentStep: 0,
      desktopCategories: [],
      timeout: null,
      sliderSpeed: 10000,
    }
  },
  methods: {
    changeSlide() {
      this.desktopSwipe()
      this.mobileSwipe()
      this.resetTimeout()
    },
    desktopSwipe() {
      let categories = [...this.desktopCategories]
      categories = [...categories.slice(1), categories[0]]
      this.desktopCategories = categories
    },
    mobileSwipe() {
      this.currentStep =
        this.currentStep < this.$store.state.categories.items.length - 1 ? this.currentStep + 1 : 0
      this.$refs.mobileSlider.scrollTo({
        left: this.$refs.mobileSlider.children[0].offsetWidth * this.currentStep,
        behavior: 'smooth',
      })
    },
    resetTimeout() {
      clearTimeout(this.timeout)
      this.timeout = setTimeout(this.changeSlide, this.sliderSpeed)
    },
  },
  mounted() {
    this.desktopCategories = [...this.$store.state.categories.items]
    this.resetTimeout()
  },
  unmounted() {
    clearTimeout(this.timeout)
  },
}
</script>
